/**
 * @desc 查询硅铝质材料需求月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthSiliconAluminumMaterialResponse>> {
  return defHttp.post({
    url: '/wap/plan/month/queryPlanSiliconAluminumMaterial',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthSiliconAluminumMaterialResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/queryPlanSiliconAluminumMaterial',
    data,
  });
}
